import React from 'react';

import { Heading, Portfolio } from '../../../components';



const PortfolioSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Our Portfolio'} subTitle={'Adventure Highlights'} />

      {/* Portfolio Section */}
      <Portfolio />

    </section>

  );
}

export default PortfolioSection;